<template>
    <v-dialog width="400" v-model="$store.state.APP.SHOW_LOGOUT">
        <v-card class="mx-auto">
            <v-card-title>
                <h2 class="text-center">Logga ut</h2>
                <v-spacer></v-spacer>


            </v-card-title>
            <v-list>
                <v-list-item>
                    <v-spacer></v-spacer>



                    <v-card  >
                        <v-avatar
                                class="profile darken-2"
                                size="100"
                                tile
                        >
                            <v-img :src="this.$store.state.MEDIA.USER_IMAGE">

                            </v-img>


                        </v-avatar>

                    </v-card>

                    <v-spacer></v-spacer>

                </v-list-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="text-center title">{{this.$store.state.STREAMER.USER_NAME}}</v-list-item-title>

                    </v-list-item-content>
                </v-list-item>
            </v-list>
            <v-divider></v-divider>


            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="logout" dark  class="purple accent-4">Logga ut</v-btn>
                <v-spacer></v-spacer>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "Logout",
        data(){
            return{

            }
        },


        methods:{
            logout: function () {
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/logout?';
                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {//Call a function when the state changes.

                    if(http.readyState === 4 && http.status > 200) {
                        console.log("error");

                    }
                    else if(http.readyState === 4 && http.status === 200){

                        self.$store.state.APP.SHOW_LOGIN=false;
                        self.$store.state.APP.SHOW_LOGOUT=false;
                        self.$store.commit("logout");


                    }
                };
                return http.send();
            }
        }
    }
</script>

<style scoped>

</style>
